// extracted by mini-css-extract-plugin
export default {"scrollBarContainer":"GenericScrollHeader_scrollBarContainer__4onQw","headerContainer":"GenericScrollHeader_headerContainer__iCuXW"};